<template>
  <layout-navigation>
    <section :class="$style.page">
      <loader v-if="isPending" />
      <div
        v-else
        :class="$style.mainFilesContainer"
      >
        <div :class="$style.textContainer">
          {{ $t('watermark.uploadImageWithQr') }}
        </div>
        <div>
          <input
            v-model="searchStringFile"
            type="text"
            :class="$style.qrInput"
            :placeholder="$t('watermark.qrCode')"
          >
          <label
            for="file-upload"
            :class="$style.fileUpload"
          >
            {{ $t('watermark.upload') }}
          </label>
          <input
            id="file-upload"
            ref="doc"
            type="file"
            @change="readFile()"
          >
        </div>
      </div>

      <div v-if="!isPending">
        <div
          v-if="candidates && candidates.length"
          :class="$style.mainFilesContainer"
        >
          <div :class="$style.textContainer">
            {{ $t('watermark.content') }}
          </div>
          <div
            v-for="(candidate, index) in candidates"
            :key="index"
            :class="$style.candidates"
          >
            <div>
              <b>{{ $t('watermark.computerName') }}:</b>
              <strong>{{ candidate.computer_name }}</strong>
            </div>

            <div>
              <b>{{ $t('watermark.userName') }}:</b>
              <strong>{{ candidate.user_name }}</strong>
            </div>

            <div>
              <b>{{ $t('watermark.timeInterval') }}:</b>
              <strong>{{ formatInterval(candidate.interval_start_utc, candidate.interval_end_utc) }}</strong>
            </div>
          </div>
        </div>
        <div v-else>
          {{ state }}
        </div>
      </div>
    </section>
  </layout-navigation>
</template>

<script>
  import LayoutNavigation from '@/layouts/navigation.vue';
  import Loader from '@/components/common/blocks/loader.vue';
  import dayjs from 'dayjs';
  import { getWatermark } from '@/api/methods/security';

  export default {
    components: {
      LayoutNavigation,
      Loader,
    },
    data() {
      return {
        searchStringFile: '',
        isPending: false,
        candidates: null,
        state: null,
      };
    },

    methods: {
      getStateText(state) {
        return this.$t(`watermark.states.${state}`);
      },
      formatInterval(startUtc, endUtc) {
        const start = dayjs.utc(startUtc * 1000).local();
        const end = dayjs.utc(endUtc * 1000).local();

        return `${start.format('DD.MM.YYYY HH:mm:ss')} - ${end.format('DD.MM.YYYY HH:mm:ss')}`;
      },
      async readFile() {
        try {
          this.isPending = true;
          this.candidates = null;

          const file = this.$refs.doc.files[0];
          const formData = new FormData();
          formData.append('image', file);
          const { data } = await getWatermark(formData);
          if (data.success) {
            this.candidates = data?.result?.candidates;
            this.state = this.getStateText(data?.result?.state);
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.isPending = false;
        }
      },
    },
  };
</script>

<style lang="scss" module>
  .page {
    background: $white;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    gap: 10px;
    padding: 20px 30px;
  }

  .textContainer {
    text-overflow: ellipsis;
    display: inline-block;
    line-height: 21px;
  }

  .mainFilesContainer {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .qrInput {
    height: 30px;
    width: 17%;
    min-width: 110px;
    margin-right: 10px;
  }

  input[type='file'] {
    display: none;
  }

  .fileUpload {
    display: inline-flex;
    min-height: 36px;
    align-items: center;
    padding: 0 12px;
    border: 1px solid var(--ui-primary);
    border-radius: 8px;
    color: #ffffff;
    background: var(--ui-primary);
    box-shadow: 0 5px 12px rgba(20, 120, 232, 0.18);
  }

  .candidates {
    display: flex;
    flex-direction: column;
    gap: 5px;
    strong {
      font-weight: 600;
      margin-left: 10px;
    }
  }
</style>
